import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const operatorsExercises: TopicExercises = {
  mcqs: [
    {
      id: "op1",
      question: "5 + 2 * 3 = ?",
      options: ["7", "11", "21", "10"],
      correctIndex: 1,
      explanation: "Multiplication pehle hoti hai, is liye 2 * 3 = 6 aur phir 5 + 6 = 11.",
    },
    {
      id: "op2",
      question: "10 % 3 ka result kya hoga?",
      options: ["3", "1", "0", "10"],
      correctIndex: 1,
      explanation: "Modulus remainder deta hai. 10 ko 3 se divide karne par remainder 1 bachta hai.",
    },
    {
      id: "op3",
      question: "Agar a = 7 aur b = 7 ho to a == b kya return karega?",
      options: ["7", "False", "True", "Error"],
      correctIndex: 2,
      explanation: "`==` equality check karta hai. Dono values same hain to answer True hai.",
    },
  ],
  short: [
    {
      id: "ops-short-1",
      question: "Comparison operator kya hota hai?",
      answer: "Comparison operator do values compare karta hai aur result `True` ya `False` deta hai, jaise >, < aur ==.",
    },
    {
      id: "ops-short-2",
      question: "Assignment operator ka basic kaam kya hai?",
      answer: "Assignment operator variable ko value assign ya update karta hai, jaise =, += aur -=.",
    },
  ],
  long: [
    {
      id: "ops-long-1",
      question: "Expression evaluate karo aur step-by-step solution likho: (5 + 3) * 2",
      solution: "Pehle bracket solve hota hai: 5 + 3 = 8. Phir 8 * 2 = 16.",
      steps: [
        "Bracket ke andar wali expression pehle solve hoti hai.",
        "5 + 3 = 8.",
        "Ab bacha 8 * 2.",
        "Final answer 16 hai.",
      ],
      code: "value = (5 + 3) * 2\nprint(value)",
    },
  ],
};
